module.exports = __webpack_public_path__ + "static/OR4-249fd5ac63534405fca08cbbec9bb959.jpg";